import { ArrowRightOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Empty, Skeleton, TablePaginationConfig, Tooltip } from 'antd';
// import { Button } from 'antd/es/radio';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Table } from 'components';
import {
    StyledTableHeader,
    StyledTableWrapper,
} from 'components/table/table.styled';
import { TableLoader } from 'components/table-loader/table-loader';
import dayjs from 'dayjs';
import { NotificationListsFilterFormValuesPaginated } from 'features/notification/components/type';
//import { UpdateStatus } from 'features/notification/use-cases/update-status';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Notificationtype } from 'types/notification-type';


type NotificationTableProps = {
    isUsersListLoading: boolean;
    typeReportList: Notificationtype[];
    itemsCount: number;
    tableParams: NotificationListsFilterFormValuesPaginated;
    refetch: any
    updateParams: Dispatch<SetStateAction<NotificationListsFilterFormValuesPaginated>>;
};

export const NotificationsListsTable = ({
    typeReportList,
    isUsersListLoading,
    itemsCount,
    tableParams,
    updateParams,
    refetch,
}: NotificationTableProps) => {
    const { t } = useTranslation();
    const handleTableChange = (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<Notificationtype> | SorterResult<Notificationtype>[],
    ) => {
        updateParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            order_by: Array.isArray(sorter)
                ? undefined
                : sorter.order === 'ascend'
                    ? 'name'
                    : '-name',
        });
    };

    const navigate = useNavigate();
    const showNotificationDetail = (record: any) => {
        navigate(`/notification/${record.NotificationId}/detail`);
    }

    return (
        <StyledTableWrapper>
            <StyledTableHeader>
                <RecordCountBadge
                    text={t('vendingMachine.foundRecord')}
                    count={isUsersListLoading ? 0 : itemsCount || 0}
                />
               
                <Tooltip title="Refresh"> 
                    <Button
                        icon={<ReloadOutlined />}
                        loading={isUsersListLoading}
                        onClick={refetch}
                        className="refresh-btn"
                    >
                        Refresh
                    </Button>
                </Tooltip>
            </StyledTableHeader>
            <Table<Notificationtype>
                className="cstltblwthldr"
                locale={{
                    emptyText: isUsersListLoading ? <Skeleton active={true} /> : <Empty />
                }}
                loading={isUsersListLoading && { indicator: <div><TableLoader /></div> }}
                dataSource={isUsersListLoading ? [] : typeReportList}
                rowKey='id'
                onChange={handleTableChange}

                onRow={(record) => ({
                    onClick: () => {
                        const selection = window?.getSelection()?.toString();


                        if (!selection?.length) {
                            showNotificationDetail(record);
                        }
                    },
                    style: { cursor: 'pointer' }
                })}


                pagination={{
                    current: tableParams.page,
                    defaultPageSize: tableParams.size,
                    total: itemsCount,
                }}
            >
                <Column
                    key={'detail'}
                    title={''}
                    dataIndex={'detail'}
                    render={() => <ArrowRightOutlined />}

                // onCell={(record) => {
                //     return {
                //         onClick: () => {
                //             const selection = window?.getSelection()?.toString();
                //             if (!selection?.length) {
                //                 showNotificationDetail(record)
                //             }
                //         },
                //     };
                // }}
                />

                <Column<Notificationtype>
                    title={'Templates '}
                    dataIndex={'TemplateName'}
                />
                <Column<Notificationtype>
                    title={'Title '}
                    dataIndex={'Title'}
                />
                <Column<Notificationtype>
                    title={'Message '}
                    dataIndex={'Message'}
                    render={(value: string) => (
                        <div dangerouslySetInnerHTML={{ __html: value }} />
                    )}
                />
                <Column<Notificationtype>
                    title={'CreatedOn '}
                    dataIndex={'CreatedOn'}
                    render={(value: string) => dayjs(value).format("DD/MM/YYYY")}
                />
                {/* <Column<Notificationtype>
                    title={'SendOn '}
                    dataIndex={'title'}
                /> */}
                <Column<Notificationtype>
                    title={'Delivery Type '}
                    dataIndex={'DeliveryType'}
                />

                {/* <Column
                    title="Status"
                    dataIndex="IsActive"
                    render={(text, record: any) => (record.IsActive ? 'Active' : 'Inactive')}
                /> */}
                <Column
                    title="Sent/Total"
                    dataIndex="SentTotal"
                // render={(text, record: any) => (record.IsActive ? 'Active' : 'Inactive')}
                />
                {/* <Column
                    title="Action"
                    dataIndex="email_address"
                    render={(_, record: any) => (
                        <Space>
                            <Tooltip title="Copy">
                                <Button
                                    shape="circle"
                                    //onClick={() => handleOpenModal(record)}
                                    icon={<CopyOutlined />}
                                />
                                
                            </Tooltip>

                            <Tooltip title="Delete">
                                <Button
                                    shape="circle"
                                   // onClick={() => showDeleteConfirm(record)}
                                    icon={<DeleteOutlined />}
                                />
                            </Tooltip>
                        </Space>
                    )}
                /> */}
            </Table>
        </StyledTableWrapper>
    );
};
